import { useBuilderStore } from "./useBuilderStore";

export interface OnClickToggleSectionProps {
  shouldKeepSidebarOpen?: boolean;
  viewName: string;
}

export const useOnClickToggleSection = ({
  viewName,
  shouldKeepSidebarOpen = false,
}: OnClickToggleSectionProps) => {
  const actionSidebarView = useBuilderStore(state => state.actionSidebarView);
  const toggleSidebarView = useBuilderStore(state => state.toggleSidebarView);

  return () => {
    if (actionSidebarView === viewName && shouldKeepSidebarOpen) {
      return;
    }
    toggleSidebarView(viewName);
  };
};
